import React from 'react';

import { useTheme } from '@mui/material/styles';

function BackIcon() {
    const theme = useTheme();

    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="31" height="31" rx="7.5" fill={theme.palette.background.paper} stroke={theme.palette.border.main} />
            <path stroke={theme.palette.text.primary} strokeWidth="2" strokeLinecap="square" d="M18 12L14 16L18 20" />
        </svg>
    );
}

export default BackIcon;
